import React from 'react'
interface IconProps {
  name: string
  className?: string
}
const Icon: React.FC<IconProps> = ({ name, className }) => (
  <span id={name} className={`icon ${name} ${className}`}></span>
)

export default Icon
